import { getAccessToken } from './helper';
import { axiosBase } from './axios';

let _sessionInvalidCallback: (() => void) | null = null;

export const registerSessionInvalidCallback = (cb: () => void) => {
  _sessionInvalidCallback = cb;
};

export const triggerSessionInvalid = () => {
  if (_sessionInvalidCallback) _sessionInvalidCallback();
};

export const validateSession = async (): Promise<boolean> => {
  const token = getAccessToken();
  if (!token) return false;
  try {
    const response = await axiosBase.post('/auth/verifyToken', { token });
    if (response?.data?.resultObject?.isValid) return true;
    return false;
  } catch (err: any) {
    const message: string = err?.response?.data?.errorMessage || '';
    if (err?.response?.data?.success === false && 
        (message.toLowerCase().includes('session') || message.toLowerCase().includes('device'))) {
      return false;
    }
    return true;
  }
};